export default __webpack_public_path__ + "static/media/LO05.03ee083d.mp3";